/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import { getFromLS } from '@orientaction/utils';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useTest from '../../../../../hooks/useTest';
import { getMe } from '../../../../../services/user.service';
import { publicLogoPath } from '../../../../../utils/constants';
import { apiServiceNative } from '../../../../../utils/fetchNative';
import RedesignThemeProvider from '../../../RedesignThemeProvider';
import RedesignImage from '../../../shared/components/RedesignImage';
import { useMinorTestPresentationStyles } from './index.styles';

const parseStoredUser = () => {
  try {
    return JSON.parse(getFromLS('userInfos') || '{}');
  } catch {
    return {};
  }
};

const MinorTestPresentation = () => {
  const classes = useMinorTestPresentationStyles();
  const history = useHistory();
  const { id }: any = useParams();
  const { getTestPresentation, test, loadPage } = useTest();
  const token = getFromLS('userToken') || '';
  const userConnected = useMemo(parseStoredUser, []);

  const [testsToDo, setTestsToDo] = useState<any[]>([]);
  const [testsToSee, setTestsToSee] = useState<any[]>([]);
  const [loadingMe, setLoadingMe] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchMe = async () => {
      setLoadingMe(true);
      try {
        const dataMe = await getMe(token);
        if (isMounted && dataMe?.data) {
          setTestsToDo(dataMe.data.tests_to_do || []);
          setTestsToSee((dataMe.data.tests_to_see_result || []).map((item: any) => item.id));
        }
      } finally {
        if (isMounted) setLoadingMe(false);
      }
    };

    if (token) fetchMe();
    getTestPresentation(id);

    return () => {
      isMounted = false;
    };
  }, []);

  const goBack = () => {
    if (userConnected?.id) {
      history.push('/user/tests');
      return;
    }

    history.goBack();
  };

  const startTest = async () => {
    if (!test?.id) return;

    setLoadingButton(true);

    if (token && userConnected?.id) {
      try {
        const nextTestsToDo = testsToDo
          .filter((item: any) => item.id !== parseInt(id, 10))
          .map((item: any) => item.id);
        const nextTestsToSee = Array.from(new Set([...testsToSee, parseInt(id, 10)]));

        await apiServiceNative.put(`/api/users/${userConnected.id}`, {
          tests_to_do: nextTestsToDo,
          tests_to_see_result: nextTestsToSee,
        });
      } catch {
        setLoadingButton(false);
        return;
      }
    }

    setLoadingButton(false);
    history.push(`/test/${test.id}/passer/${kebabCase(test.attributes.title)}`);
  };

  const renderHeader = () => (
    <header className={classes.header}>
      <button
        type="button"
        className={classes.logoButton}
        onClick={() => history.push(userConnected?.id ? '/main' : '/')}>
        <RedesignImage
          src={`${publicLogoPath}/e-orientaction-redesign.png`}
          alt="E-Orientaction"
          className={classes.logo}
        />
      </button>
      <div className={classes.headerActions}>
        <div className={classes.phoneBlock}>
          <div className={classes.phoneLine}>
            <PhoneIcon fontSize="small" />
            <span>02 43 72 25 88*</span>
          </div>
          <p className={classes.phoneNote}>*Numéro national non surtaxé</p>
        </div>
        <Button
          className={classNames(classes.button, classes.primaryButton)}
          startIcon={<MailOutlineIcon />}
          onClick={() => {
            window.location.href = 'mailto:contact@orientaction.com';
          }}>
          Nous contacter
        </Button>
      </div>
    </header>
  );

  if (loadPage || loadingMe || !test?.attributes) {
    return (
      <RedesignThemeProvider>
        <div className={classes.page}>
          {renderHeader()}
          <div className={classes.loadingCenter}>
            <CircularProgress />
          </div>
        </div>
      </RedesignThemeProvider>
    );
  }

  return (
    <RedesignThemeProvider>
      <div className={classes.page}>
      {renderHeader()}
      <main className={classes.main}>
        <div className={classes.backButtonWrap}>
          <Button className={classes.button} startIcon={<ArrowBackIcon />} onClick={goBack}>
            Retour
          </Button>
        </div>

        <section className={classes.layout}>
          <div className={classes.imageWrap}>
            <RedesignImage
              src={test.attributes.image}
              alt={test.attributes.title}
              className={classes.image}
            />
          </div>

          <div className={classes.card}>
            <div className={classes.content}>
              <Typography component="h1" className={classes.title}>
                {test.attributes.title || 'En attente...'}
              </Typography>

              <div className={classes.duration}>
                <AccessTimeIcon fontSize="small" />
                <span>Durée du test : {test.attributes.time || ' '} min</span>
              </div>

              <div
                className={classes.description}
                dangerouslySetInnerHTML={{
                  __html: test.attributes.description || 'En attente...',
                }}
              />
            </div>

            <Button
              className={classNames(classes.button, classes.primaryButton, classes.startButton)}
              onClick={startTest}
              disabled={loadingButton}
              startIcon={
                loadingButton ? <CircularProgress size={18} color="inherit" /> : undefined
              }>
              C&apos;est parti
            </Button>
          </div>
        </section>
      </main>
      </div>
    </RedesignThemeProvider>
  );
};

export default MinorTestPresentation;
